import type { SelectButtonProps } from '~/components/SelectButton/SelectButton';
import SelectButton from '~/components/SelectButton/SelectButton';
export { SelectButtonProps };
export default SelectButton;
